import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

import { Button } from '@/components/ui/button';
import { TherapyAttribute } from '@repo/types/src/glow-up';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { useDeleteTherapyAttribute } from '@/api/glow-up/glow-up.hooks';
import { useState } from 'react';

type DeleteTherapyAttributeProps = {
  attribute: TherapyAttribute;
  refetch: () => void;
};

export const DeleteTherapyAttribute = ({
  attribute,
  refetch,
}: DeleteTherapyAttributeProps) => {
  const mutation = useDeleteTherapyAttribute();
  const [open, setOpen] = useState(false);

  const handleDelete = () => {
    mutation.mutate(attribute.id, {
      onSuccess: () => {
        setOpen(false);
        refetch();
        toast.success(
          `L’attribut de thérapie "${attribute.name}" a été supprimé`,
          { duration: 3000 },
        );
      },
      onError: () => {
        toast.error(
          `Erreur lors de la suppression de l’attribut "${attribute.name}"`,
          { duration: 3000 },
        );
      },
    });
  };

  const isLoading = mutation.isPending;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive" size="sm" disabled={isLoading}>
          <Trash2 size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-center">
            Supprimer l’attribut
          </DialogTitle>
          <DialogDescription className="text-center">
            Voulez-vous vraiment supprimer l’attribut "{attribute.name}" ? Cette
            action est irréversible.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex gap-2">
          <DialogClose asChild>
            <Button variant="ghost" disabled={isLoading}>
              Annuler
            </Button>
          </DialogClose>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isLoading}
          >
            {isLoading ? 'Suppression...' : 'Supprimer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
